
import { useState } from 'react';

export default function PuraVida() {
  // Using plain JavaScript state (no TypeScript generics) to avoid syntax errors
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    'https://i.imgur.com/I2CylYL.jpg',
    'https://i.imgur.com/tXkRw6U.jpg',
    'https://i.imgur.com/yuyDEZZ.jpg',
    'https://i.imgur.com/WzNdH1I.jpg',
  ];

  const roomTypes = [
    {
      name: 'FLORESTA',
      icon: 'ri-plant-line',
      capacity: '1-3 dorosłych',
      size: '30 m² w przybliżeniu (wliczając taras/balkon)',
      image: 'https://i.imgur.com/qqTwZrk.jpg',
    },
    {
      name: 'VILLA SUITES',
      icon: 'ri-home-smile-line',
      capacity: '2-4 dorosłych',
      size: '100 m² w przybliżeniu (wliczając taras/balkon)',
      image: 'https://i.imgur.com/WzNdH1I.jpg',
    },
  ];

  const amenities = [
    { icon: 'ri-temp-cold-line', label: 'Klimatyzacja' },
    { icon: 'ri-goblet-line', label: 'Minibar (na życzenie)' },
    { icon: 'ri-safe-line', label: 'Sejf' },
    { icon: 'ri-music-line', label: 'Kanały muzyczne' },
    { icon: 'ri-phone-line', label: 'Telefon w pokojach' },
    { icon: 'ri-tv-line', label: 'Telewizja satelitarna' },
    { icon: 'ri-flashlight-line', label: 'Napięcie 220V' },
    { icon: 'ri-scissors-cut-line', label: 'Suszarka do włosów' },
    {
      icon: 'ri-layout-line',
      label: 'Floresta 30 m² w przybliżeniu (wliczając taras/balkon)',
    },
    {
      icon: 'ri-layout-line',
      label: 'Villa Suite 100 m² w przybliżeniu (wliczając taras/balkon)',
    },
    { icon: 'ri-hotel-bed-line', label: 'Karta poduszek' },
    { icon: 'ri-brush-line', label: 'Kosmetyki Eco-Boutique' },
    { icon: 'ri-cup-line', label: 'Zestaw do kawy i herbaty' },
    { icon: 'ri-drop-line', label: 'Woda powitalna' },
    { icon: 'ri-shirt-line', label: 'Szlafrok i kapcie' },
    { icon: 'ri-sun-line', label: 'Łóżka balińskie Club Laurel (w zależności od dostępności)' },
  ];

  // Helper to safely set image – prevents setting undefined/null accidentally
  const openLightbox = (url) => {
    if (url && typeof url === 'string') {
      setSelectedImage(url);
    }
  };

  // Helper to close the lightbox
  const closeLightbox = () => setSelectedImage(null);

  return (
    <>
      <section
        id="pura-vida"
        className="py-24 px-6 bg-gradient-to-b from-emerald-50 to-white relative overflow-hidden"
      >
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-emerald-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-400 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto relative">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block px-6 py-2 bg-emerald-100 rounded-full mb-6">
              <span className="text-emerald-800 font-medium text-sm tracking-wide">
                +16 TYLKO DLA DOROSŁYCH
              </span>
            </div>
            <h2 className="text-5xl md:text-6xl font-light text-stone-800 mb-6">Pura Vida</h2>
            <div className="w-24 h-1 bg-emerald-400 mx-auto mb-8"></div>
            <p className="text-xl text-stone-700 font-medium mb-4">Widoki panoramiczne na ogrody i/lub morze</p>
            <p className="text-2xl text-emerald-700 font-light italic mb-8">
              NIE MARZ O TYM, PRZEŻYJ TO!
            </p>
          </div>

          {/* Main content card */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden mb-12">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="relative h-96 md:h-auto min-h-[400px]">
                <img
                  src="https://i.imgur.com/I2CylYL.jpg"
                  alt="Strefa Pura Vida"
                  className="w-full h-full object-cover cursor-pointer hover:opacity-90 transition-opacity"
                  onClick={() => openLightbox('https://i.imgur.com/I2CylYL.jpg')}
                />
              </div>
              <div className="p-10 flex flex-col justify-center">
                <p className="text-stone-600 leading-relaxed mb-6">
                  Odkryj Pura Vida by Jardín Tecina – strefę tylko dla dorosłych, gdzie możesz odłączyć się od
                  codzienności i cieszyć maksymalną prywatnością oraz najlepszymi panoramicznymi widokami na pole
                  golfowe, ogrody i ocean.
                </p>
                <p className="text-stone-600 leading-relaxed mb-6">
                  W tym ekskluzywnym otoczeniu oferujemy maksymalny komfort i prywatność z łóżkami balińskimi, 1
                  prywatnym basenem i 2 jacuzzi. Dodatkowo ciesz się spersonalizowaną obsługą napojów i przekąsek
                  (usługa dodatkowo płatna, godziny: 11-18h zima, 11-19h lato).
                </p>
                <p className="text-stone-600 leading-relaxed mb-6">
                  Nasze Villa Suites lub pokoje Floresta będą najlepszym wyborem, jeśli szukasz zanurzenia się w
                  luksusie i spokoju zarezerwowanym tylko dla dorosłych.
                </p>
                <p className="text-stone-700 font-medium mb-4">
                  Pojemność pokoi Villa Suites od 2 do 4 dorosłych, a pokoi Floresta od 1 do 3 dorosłych (minimalny
                  wiek 16 lat).
                </p>
                <p className="text-sm text-stone-500 italic">
                  Charakterystyka pokoi, taka jak lokalizacja lub wyposażenie, może się nieznacznie różnić
                </p>
              </div>
            </div>
          </div>

          {/* Two room types - Large icons */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {roomTypes.map((room, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow cursor-pointer group"
                onClick={() => openLightbox(room.image)}
              >
                <div className="relative h-64">
                  <img
                    src={room.image}
                    alt={room.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="flex items-center gap-4">
                      <div className="w-16 h-16 flex items-center justify-center bg-emerald-500 rounded-full">
                        <i className={`${room.icon} text-white text-3xl`}></i>
                      </div>
                      <div>
                        <h3 className="text-2xl font-light text-white tracking-wider">{room.name}</h3>
                        <p className="text-emerald-200 text-sm">{room.capacity}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-6 bg-emerald-50">
                  <div className="flex items-center gap-2 text-emerald-700">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-ruler-line"></i>
                    </div>
                    <span className="text-sm">{room.size}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Gallery */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {images.slice(1).map((img, index) => (
              <div
                key={index}
                className="relative h-80 rounded-lg overflow-hidden shadow-lg cursor-pointer group"
                onClick={() => openLightbox(img)}
              >
                <img
                  src={img}
                  alt={`Pura Vida ${index + 2}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/90 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-zoom-in-line text-stone-800 text-xl"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Amenities grid */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
            <h3 className="text-2xl font-light text-stone-800 mb-8 text-center">
              Udogodnienia w pokojach Pura Vida
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {amenities.map((amenity, idx) => (
                <div key={idx} className="flex items-center gap-3 p-3 bg-stone-50 rounded-lg">
                  <div className="w-8 h-8 flex items-center justify-center bg-emerald-100 rounded-full shrink-0">
                    <i className={`${amenity.icon} text-emerald-600`}></i>
                  </div>
                  <span className="text-xs text-stone-600 leading-tight">{amenity.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Features highlights */}
          <div className="grid md:grid-cols-4 gap-6 mb-12">
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                <i className="ri-user-forbid-line text-emerald-600 text-2xl"></i>
              </div>
              <h4 className="font-medium text-stone-800 mb-2">Tylko dla dorosłych</h4>
              <p className="text-sm text-stone-600">Wiek minimalny: 16 lat</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                <i className="ri-water-flash-line text-emerald-600 text-2xl"></i>
              </div>
              <h4 className="font-medium text-stone-800 mb-2">Prywatny basen</h4>
              <p className="text-sm text-stone-600">I 2 jacuzzi</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                <i className="ri-eye-line text-emerald-600 text-2xl"></i>
              </div>
              <h4 className="font-medium text-stone-800 mb-2">Widoki panoramiczne</h4>
              <p className="text-sm text-stone-600">Golf, ogrody, ocean</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                <i className="ri-vip-crown-line text-emerald-600 text-2xl"></i>
              </div>
              <h4 className="font-medium text-stone-800 mb-2">Obsługa premium</h4>
              <p className="text-sm text-stone-600">Napoje i przekąski</p>
            </div>
          </div>

          {/* Info box */}
          <div className="bg-emerald-50 border-2 border-emerald-200 rounded-xl p-8">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-emerald-700 text-2xl"></i>
              </div>
              <div>
                <h4 className="text-lg font-medium text-emerald-900 mb-2">Informacje dodatkowe</h4>
                <p className="text-emerald-800 leading-relaxed">
                  Nasze Villa Suites lub pokoje Floresta będą najlepszym wyborem, jeśli szukasz zanurzenia się w
                  luksusie i spokoju zarezerwowanym tylko dla dorosłych. Charakterystyka pokoi, taka jak lokalizacja
                  czy wyposażenie, może się nieznacznie różnić.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            onClick={closeLightbox}
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>
          <img
            src={selectedImage}
            alt="Podgląd"
            className="max-w-full max-h-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
            // Fallback handling if the image fails to load
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/800x600?text=Image+not+available';
            }}
          />
        </div>
      )}
    </>
  );
}
